import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";

@Injectable()
export class AreaService {
  
  private base_url = `${environment.API_URL}/areas`;
  private single_url = `${environment.API_URL}/area`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  // Get all areas
  getAreas(params) {
    return this.http
      .post(this.base_url, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  //get single area
  getArea(area_id:number) {
    return this.http
      .get(`${this.single_url}/${area_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  // autocomplete cities
  autocompleteAreas(query) {
    let params = {
      //token: this.token,
      query: query,
    };
    return this.http
      .post(`${this.base_url}/autocomplete`, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  // create city
  createArea(params) {
    //params["token"] = this.token;
    return this.http
      .post(this.single_url, params, { headers: this.headers })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response.id) {
          // If the response is an Object with an ID, this means a success
          this.toast.success("Aone Ajoutée avec succès.", false, "Zone");
        } else {
          this.toast.error(
            "Erreur lors de l'ajout de la zone.",
            false,
            "Zone"
          );
        }
        return response;
      });
  }

  //delete city
  deleteArea(area_id:number) {
    return this.http
      .delete(`${this.single_url}/${area_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success(
            "Zone Supprimée avec succès.",
            false,
            "Zone"
          );
        } else {
          this.toast.error(
            "Erreur lors de la suppression de la zone.",
            false,
            "Zone"
          );
        }
      });
  }

  //update city
  updateArea(area_id:number, params) {
    return this.http
      .patch(`${this.single_url}/${area_id}?token=${this.token}`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success(
            "Zone Mise à jour avec succès.",
            false,
            "Zone"
          );
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour de la zone.",
            false,
            "Zone"
          );
        }
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/area.service.ts